import React from "react";
import "./Marquee.css";

const Marquee = ({ messages }) => {
  const items = messages || [
    "Admissions open — Apply now.",
    "New course: Additive Manufacturing M.Tech — See details.",
    "Check latest News & Events on the website.",
  ];

  return (
    <div className="cip-marquee-wrapper" aria-live="polite">
      <div className="cip-marquee">
        <div className="cip-marquee-track">
          {items.map((m, i) => (
            <span key={i} className="cip-marquee-item">
              {m}
            </span>
          ))}
        </div>
        <div className="cip-marquee-track" aria-hidden="true">
          {items.map((m, i) => (
            <span key={`dup-${i}`} className="cip-marquee-item">
              {m}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
